import { LazyQueryResultTuple, useLazyQuery, OperationVariables } from '@apollo/client';
import { GET_PINNED_COST_CODES_BY_CREW } from '@bechtel/client-gql';
import { PinnedCostCodeCollection } from '@bechtel/types';

export function usePinnedCostCodesByCrew(
  fetchFromNetwork?: boolean
): LazyQueryResultTuple<{ pinnedCostCodesByCrew: PinnedCostCodeCollection }, OperationVariables> {
  const response = useLazyQuery<
    {
      pinnedCostCodesByCrew: PinnedCostCodeCollection;
    },
    OperationVariables
  >(
    GET_PINNED_COST_CODES_BY_CREW,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
